export default "__VITE_ASSET__CCUm5iPf__"